import React from 'react';
import styled from 'styled-components/macro';

import { flexCenter } from 'styles/styled-mixins';

import Loading from 'components/Loading';


const AppLoading = (props) => {
    return (
        <Container {...props}>
            <MainLoading/>
        </Container>
    );
};


export default AppLoading;


const Container = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    ${flexCenter};
    
    font-size: 10rem;
    
    background-color: ${props => props.theme.primary_color};
`;

const MainLoading = styled(Loading)`
    font-size: 18rem;
`;
